/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Conversation API response with participant info
 * @export
 * @interface IConversationResponse
 */
export interface IConversationResponse {
    /**
     * 
     * @type {string}
     * @memberof IConversationResponse
     */
    id?: string;
    /**
     * The OTHER participant (not the requesting user)
     * @type {string}
     * @memberof IConversationResponse
     */
    participantId?: string;
    /**
     * 
     * @type {string}
     * @memberof IConversationResponse
     */
    participantUsername?: string;
    /**
     * 
     * @type {string}
     * @memberof IConversationResponse
     */
    participantAvatarUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IConversationResponse
     */
    isOnline?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IConversationResponse
     */
    lastMessageContent?: string;
    /**
     * 
     * @type {number}
     * @memberof IConversationResponse
     */
    lastMessageAt?: number;
    /**
     * 
     * @type {string}
     * @memberof IConversationResponse
     */
    lastMessageSenderId?: string;
    /**
     * 
     * @type {number}
     * @memberof IConversationResponse
     */
    unreadCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IConversationResponse
     */
    isMuted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IConversationResponse
     */
    isArchived?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IConversationResponse
     */
    createdAt?: number;
}

/**
 * Check if a given object implements the IConversationResponse interface.
 */
export function instanceOfIConversationResponse(value: object): value is IConversationResponse {
    return true;
}

export function IConversationResponseFromJSON(json: any): IConversationResponse {
    return IConversationResponseFromJSONTyped(json, false);
}

export function IConversationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IConversationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'participantId': json['participantId'] == null ? undefined : json['participantId'],
        'participantUsername': json['participantUsername'] == null ? undefined : json['participantUsername'],
        'participantAvatarUrl': json['participantAvatarUrl'] == null ? undefined : json['participantAvatarUrl'],
        'isOnline': json['isOnline'] == null ? undefined : json['isOnline'],
        'lastMessageContent': json['lastMessageContent'] == null ? undefined : json['lastMessageContent'],
        'lastMessageAt': json['lastMessageAt'] == null ? undefined : json['lastMessageAt'],
        'lastMessageSenderId': json['lastMessageSenderId'] == null ? undefined : json['lastMessageSenderId'],
        'unreadCount': json['unreadCount'] == null ? undefined : json['unreadCount'],
        'isMuted': json['isMuted'] == null ? undefined : json['isMuted'],
        'isArchived': json['isArchived'] == null ? undefined : json['isArchived'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
    };
}

export function IConversationResponseToJSON(json: any): IConversationResponse {
    return IConversationResponseToJSONTyped(json, false);
}

export function IConversationResponseToJSONTyped(value?: IConversationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'participantId': value['participantId'],
        'participantUsername': value['participantUsername'],
        'participantAvatarUrl': value['participantAvatarUrl'],
        'isOnline': value['isOnline'],
        'lastMessageContent': value['lastMessageContent'],
        'lastMessageAt': value['lastMessageAt'],
        'lastMessageSenderId': value['lastMessageSenderId'],
        'unreadCount': value['unreadCount'],
        'isMuted': value['isMuted'],
        'isArchived': value['isArchived'],
        'createdAt': value['createdAt'],
    };
}

